import axios from 'axios';
import QS from 'qs';
import router from '@/router'
import { Message } from 'element-ui';
let ctbtGroup = null
try {
  ctbtGroup = JSON.parse(sessionStorage.getItem('ctbtGroup'))
}catch (e) {

}
axios.defaults.crossDomain = true;
axios.defaults.timeout = 120000;
axios.interceptors.request.use(
  config => {
    accessToken(config);
    return config;
  },
  error => {
    return Promise.error(error);
  })
axios.interceptors.response.use(
  response => {
    //console.log(response)
    // 否则的话抛出错误
    if (response.data.code === 401) {//token失效
      Message({
        showClose: true,
        message: '登录已过期',
        type: 'warning'
      });
      router.push('/login');
      return Promise.resolve(response);
    } else {
      return Promise.resolve(response);
    }
  },
  error => { // 这里对 error 预期结果是包含具体错误信息和状态码
    return Promise.reject(error);
  })
//处理token
function accessToken(config){
  let tokenKey = sessionStorage.getItem("token");
  if(!tokenKey){
    return;
  }
  config.headers['Authorization'] = 'Bearer ' + tokenKey
}
axios.$get = function(url, params,myConfig){
  return new Promise((resolve, reject) =>{
    let config= {
      params: params
    }
    if(myConfig){
      config=Object.assign(config,myConfig);
    }
    axios.get(url,config,
      {
        headers:{'Content-Type':'application/x-www-form-urlencoded'},
      }).then(res => {
      resolve(res.data);
    }).catch(err =>{
      reject(err)
    })
  })
}
axios.$post = function(url, params) {
  var headers = {
    'Content-Type':'application/x-www-form-urlencoded',
  };
  return new Promise((resolve, reject) => {
    axios.post(url, QS.stringify(params),
      {
        headers:headers,
      }).then(res => {
      resolve(res.data);
    })
      .catch(err =>{
        console.log(err)
        reject(err.data)
      })
  })
}
axios.$put = function(url, params) {
  return new Promise((resolve, reject) => {
    axios.put(url, QS.stringify(params),
      {
        headers:{'Content-Type':'application/x-www-form-urlencoded'},
      },
    ).then(res => {
      resolve(res.data);
    })
      .catch(err =>{
        reject(err.data)
      })
  })
}

axios.$delete = (url) =>{
  return new Promise((resolve, reject) =>{
    axios.delete(url).then(res => {
      resolve(res.data);
    }).catch(err =>{
      reject(err.data)
    })
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/api/http.js